export default "__VITE_ASSET__De6i2Xbb__"